<fuse-alert
    *ngIf="!!alert.message"
    class="guest-auth-fuse-alert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
</fuse-alert>

<!-- Step 1 -->
<ng-container *ngIf="!verifyPasscodeStep">
    <form
        id="guestEmailForm"
        class="auth-form-wrapper-shallow guest-auth-email-form"
        [formGroup]="guestEmailForm"
        #guestEmailNgForm="ngForm">

        <mat-form-field class="auth-form-field guest-auth-email-form-field">
            <mat-label>Please provide your email address</mat-label>
            <input
                id="guestEmail"
                matInput
                [formControlName]="'email'">
            <mat-error *ngIf="guestEmailForm.get('email').hasError('required')">
                Please enter your email address
            </mat-error>
            <mat-error *ngIf="guestEmailForm.get('email').hasError('email')">
                Please enter a valid email address
            </mat-error>
        </mat-form-field>

        <button
            class="auth-form-flat-button guest-auth-email-submit-button fuse-mat-button-large"
            mat-flat-button
            [color]="'primary'"
            [disabled]="guestEmailForm.disabled || !guestEmailForm.valid"
            (click)="authenticateGuest()">
            <span *ngIf="!guestEmailForm.disabled">
                Request Passcode
            </span>
            <mat-progress-spinner
                *ngIf="guestEmailForm.disabled"
                [diameter]="24"
                [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
    </form>
</ng-container>

<!-- Step 2 -->
<ng-container *ngIf="verifyPasscodeStep">
    <form
        id="guestPasscodeForm"
        class="auth-form-wrapper-shallow guest-auth-passcode-form-wrapper"
        [formGroup]="guestPasscodeForm"
        #guestPasscodeNgForm="ngForm">

        <mat-form-field class="auth-form-field">
            <mat-label>Passcode</mat-label>
            <input
                id="guestPasscode"
                matInput
                [formControlName]="'passcode'">
            <mat-error *ngIf="guestPasscodeForm.get('passcode').hasError('required')">
                Please enter a valid code
            </mat-error>
        </mat-form-field>

        <button
            class="auth-form-flat-button guest-auth-passcode-submit-button fuse-mat-button-large"
            mat-flat-button
            [color]="'primary'"
            [disabled]="guestPasscodeForm.disabled || !guestPasscodeForm.valid"
            (click)="verifyGuestPasscode()">
            <span *ngIf="!guestPasscodeForm.disabled">
                Login
            </span>
            <mat-progress-spinner
                *ngIf="guestPasscodeForm.disabled"
                [diameter]="24"
                [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
    </form>
</ng-container>
